import React from "react";
export default function MarketingData() {
  return [
    {
      text: [
        {
          title: "Typical Monthly Premiums",
          paragraphs: [<TypicalMonthlyPremiums />],
        }
      ]
      ,
      image: "/product-landing/navi/circle1.png"
    },
    {
      text: [
        {
          title: "Selecting a Medicare plan made easy",
          paragraphs: ["Our licensed insurance agents will explain the benefits and costs of each option so you can make an informed decision. Our goal is to help you get the quality health coverage you need, at an affordable price."],
        }
      ]
      ,
      image: "/product-landing/navi/circle3.png"
    },
    {
      text: [
        {
          title: "Basics of Medicare",
          paragraphs: ["Medicare is health insurance provided by the government for people age 65 or those with certain disabilities. It can be broken down into four major parts."],
          link: "LEARN MORE",
          modalContent: <BasicsOfMedicare />
        }
      ]
      ,
      image: "/product-landing/navi/circle4.png",
      imageClass: "remove-circle",
    }
  ]
}

function BasicsOfMedicare() {

  return (
    <div>
      <h2>Basics of Medicare</h2>
      <br />
      <h3>Medicare has four parts</h3>
      <br />
      <h4>Part A (Hospital Insurance)</h4>
      <p>
          Covers inpatient hospital services (such as lab tests and surgeries) and supplies (such as wheelchairs and walkers) considered medically
        necessary to treat a disease or condition, if you’re admitted. Includes inpatient hospital room and board, skilled nursing care, hospice and
        some home health care costs.
      </p>
      <p>
        <b>Cost: </b> Most people do not pay a premium for Part A. There are deductibles and copays that can change each year.
      </p>
      <h4>Part B (Medical Insurance)</h4>
      <p>
          Covers medically necessary outpatient doctor visits, outpatient surgery, physical therapy, durable medical equipment (such as crutches,
      wheelchairs and home oxygen supplies), ambulance services and preventative services (such as flu shots and screenings for diabetes and cancers).
      </p>
      <p>
        <b>Cost: </b>  Everyone pays a monthly, income-tested premium for Part B — the more you make, the more you pay. Premiums and deductibles can change each year.
      </p>
      <h4>Part C (Medicare Advantage Plans)</h4>
      <p>
          A type of Medicare health plan offered by a private insurance company that contracts with Medicare to provide all Part A and Part B benefits.
      May also offer extra coverage. Always covers emergency and urgently needed care. May include Part D Prescription Drug coverage (making it an MA-PD plan).
      </p>
      <p>
        <b>Cost: </b>   Most Part C plans have low or zero premiums. Premiums vary by plan type and geography, and often include prescription drug coverage
        at no extra cost. Deductibles, co-pays and co-insurance vary by plan and can change each year.
      </p>
      <h4>Part D (Prescription Drug Plans)</h4>
      <p>
        Provides outpatient prescription drug coverage. Can be purchased on a standalone basis or be included with a Medicare Advantage plan in an
    MA-PD plan.
      </p>
      <p>
        <b>Cost: </b> Everyone pays a monthly, income-tested premium for Part D — the more you make, the more you pay. Premiums and deductibles vary
        by plan and geography and can change each year.
      </p>
      <br />
      <h3>Medicare Supplement Plans (Or Medigap)</h3>
      <p>
        Plans that can help pay some of the health care costs that Original Medicare doesn’t cover such as co-payments, co-insurance and
    deductibles. Provided by private insurance companies.
      </p>
      <p>
        <b>Cost: </b> Once accepted, a monthly premium (which can vary by plan type, geography and other variables), is required.
      </p>
    </div>
  )

}

function TypicalMonthlyPremiums() {
  return (
    <React.Fragment>
      <label className="pt-4 ft-marketing-h3">Medicare Supplement</label>
      <label className="mb-0">- Monthly premiums typically range from $85 to $150, but vary by plan and geography</label>
      <label>- Premiums can be affected by age and gender</label>
      <label className="mt-3 ft-marketing-h3">Medicare Advantage</label>
      <label className="mb-0">- Premiums can be as low as $0 per month, but you are still responsible for the Part B premium</label>
      <label>- Premiums are not impacted by age or gender, but do vary by county</label>
    </React.Fragment>
  )
}
